export const SET_QUESTIONS = 'SET_QUESTIONS'
export const SET_QUESTION = 'SET_QUESTION'
export const SET_FOLDER_TITLE = 'SET_FOLDER_TITLE'
export const SET_FOLDER_THUMBNAIL = 'SET_FOLDER_THUMBNAIL'
export const SET_FOLDER_SELECTED_QUESTIONS = 'SET_FOLDER_SELECTED_QUESTIONS'
export const FOLDER_THUMBNAIL = 'FOLDER_THUMBNAIL'
export const FOLDER_THUMBNAIL_FILE = 'FOLDER_THUMBNAIL_FILE'

export const SET_ALL_FOLDERS_QUESTIONS = 'SET_ALL_FOLDERS_QUESTIONS'

export const SET_OPEN_MOVE_QUESTION = 'SET_OPEN_MOVE_QUESTION'

export const SET_OPENED_FOLDER = 'SET_OPENED_FOLDER'

export const SET_EDIT_FOLDER = 'SET_EDIT_FOLDER'

export const SET_TOGGLE_EDIT_FOLDER = 'SET_TOGGLE_EDIT_FOLDER'

export const SET_RENAME_FOLDER = 'SET_RENAME_FOLDER'

export const SET_ADD_FOLDER_TOGGLE = 'SET_ADD_FOLDER_TOGGLE'
